import React from 'react';
import { FDClickableText, FDPrimaryActionButton } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';

export const ContactSupportButton = () => {
  const { resource } = useMetaLayoutContext();

  const isStuck = resource.withRelationship(fr.relationships.poweredBy.name, () => false, () => true);

  return resource.withRelationship(
    fr.relationships.contactSupport.name,
    (rel) => {
      if (isStuck) {
        return (
          <FDPrimaryActionButton
            href={rel.link('related').url()}
            label={rel.meta('prompt')}
          />
        );
      }

      return (
        <FDClickableText
          appearance={'standalone'}
          href={rel.link('related').url()}
          label={rel.meta('prompt')}
        />
      );
    },
    () => null,
  );
};
